module.exports = __webpack_public_path__ + "static/media/rubix.1ea24197.png";